var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flexible-content"},_vm._l((_vm.parsedContent),function(component,i){return _c(_vm.componentLoader(component),{key:i,tag:"component",attrs:{"data":component}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }